import React from "react"
import Layout from "../components/layout"
import Banner from "../components/banner"
import { Helmet } from "react-helmet"

export default function OtherServices({ data }) {
  const bannerUrl = "/assets/EFG_6503.jpg";

  return (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Prairie Process Serving</title>
      </Helmet>
      <Banner title="We serve with integrity, respect and results."  imageUrl={bannerUrl}/>
      <section className="section process">
        <div className="container content">
          <h2 className="title is-2 has-text-secondary">Other services</h2>
          <h3>Court Filing/Retrieval</h3>
          <p>We offer this service in various parts of the province. We ask that you fill out the <a href="assets/Court_Filing_Form.docx">Court Filing Form</a> and email your request to <a className="link transition" href="mailto:service@prairieprocessserving.com">service@prairieprocessserving.com</a>.</p>
          <h3>Litigation Searches</h3>
          <p>Saskatchewan Personal Property Registration [SPPR], Judgment, Court Action, Corporate Registry and Land Title Searches. We ask that you fill out the <a href="assets/Search_Request_Form.docx">Litigation Search Request Form</a> and email your request to <a className="link transition" href="mailto:service@prairieprocessserving.com">service@prairieprocessserving.com</a>.</p>
        </div>
      </section>
    </Layout>
  );
}